var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-popover', {
    attrs: {
      "offset": "0",
      "open": _vm.isOpen,
      "trigger": "click",
      "autoHide": true
    },
    on: {
      "auto-hide": _vm.close
    }
  }, [_c('span', {
    staticClass: "tooltip-target",
    attrs: {
      "data-testid": "client-banner-membership"
    },
    on: {
      "click": _vm.open
    }
  }, [(_vm.client.membership) ? [(_vm.membershipExpiresSoon(_vm.client.membership) && (_vm.client.membership.has_next_membership === false)) ? _c('span', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ({
        content: 'končí již: <b>' + _vm.client.membership.valid_to + '</b>' + (_vm.client.membership.paid === false ? '<br> <span class=\'text-danger\'>klient nezaplatil</span>' : ''),
        placement: 'bottom-center',
        classes: ['danger']
      }),
      expression: "{\n                content: 'končí již: <b>' + client.membership.valid_to + '</b>' + (client.membership.paid === false ? '<br> <span class=\\'text-danger\\'>klient nezaplatil</span>' : ''),\n                    placement: 'bottom-center',\n                    classes: ['danger']}"
    }],
    staticClass: "badge badge-primary badge_membership",
    attrs: {
      "data-testid": "client-membership-expiring"
    }
  }, [_c('i', {
    staticClass: "fa fa-warning text-danger",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), (_vm.client.membership.paid === false) ? _c('i', {
    staticClass: "fa fa-dollar text-danger",
    attrs: {
      "data-testid": "client-membership-unpaid"
    }
  }) : _vm._e(), _vm._v("\n                " + _vm._s(_vm.client.membership.name) + "\n            ")]) : _c('span', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ({
        content: 'platný do: <b>' + _vm.client.membership.valid_to + '</b>' + (_vm.client.membership.has_next_membership === true ? '<br> navazuje další program' : '') + (_vm.client.membership.paid === false ? '<br> <span class=\'text-danger\'>klient nezaplatil</span>' : ''),
        placement: 'bottom-center',
        classes: ['info']
      }),
      expression: "{\n                    content: 'platný do: <b>' + client.membership.valid_to + '</b>' + (client.membership.has_next_membership === true ? '<br> navazuje další program' : '') + (client.membership.paid === false ? '<br> <span class=\\'text-danger\\'>klient nezaplatil</span>' : ''),\n                    placement: 'bottom-center',\n                    classes: ['info']}"
    }],
    staticClass: "badge badge-primary badge_membership",
    attrs: {
      "data-testid": "client-membership-active"
    }
  }, [(_vm.client.membership.paid === false) ? _c('i', {
    staticClass: "fa fa-dollar text-danger",
    attrs: {
      "data-testid": "client-membership-unpaid"
    }
  }) : _vm._e(), _vm._v("\n                " + _vm._s(_vm.client.membership.name) + "\n            ")])] : (_vm.client.last_membership) ? _c('span', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ({
        content: 'skončil: <b>' + _vm.client.last_membership.valid_to,
        placement: 'bottom-center',
        classes: ['secondary']
      }),
      expression: "{\n            content: 'skončil: <b>' + client.last_membership.valid_to,\n            placement: 'bottom-center',\n            classes: ['secondary']}"
    }],
    staticClass: "badge badge-secondary badge_membership",
    attrs: {
      "data-testid": "client-membership-last"
    }
  }, [_c('i', {
    staticClass: "fa fa-warning",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" poslední: " + _vm._s(_vm.client.last_membership.name))]) : _c('span', {
    staticClass: "badge badge-warning badge_membership",
    attrs: {
      "data-testid": "client-membership-none"
    }
  }, [_c('i', {
    staticClass: "fa fa-warning",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" nemá program")])], 2), _vm._v(" "), _c('template', {
    slot: "popover"
  }, [(!_vm.programsPending) ? _c('div', {
    staticClass: "container tooltip_container tooltip_1_5_col"
  }, [_c('div', {
    staticClass: "row tooltip_header"
  }, [_c('div', {
    staticClass: "col-sm-2 text-left"
  }, [(_vm.editMode === false && _vm.client.membership) ? _c('button', {
    staticClass: "btn btn-sm btn-outline-secondary",
    attrs: {
      "data-testid": "client-membership-change"
    },
    on: {
      "click": _vm.edit
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" změnit")]) : (_vm.editMode === true) ? _c('button', {
    staticClass: "btn btn-sm btn-outline-secondary",
    attrs: {
      "data-testid": "client-membership-back"
    },
    on: {
      "click": _vm.view
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" zpět")]) : _vm._e()]), _vm._v(" "), (_vm.editMode === true) ? _c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("Úprava programu")]) : (!_vm.client.membership) ? _c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("Výběr programu")]) : _c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("Detail programu")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  })]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', {
    staticClass: "row m-0"
  }, [_c('th', {
    staticClass: "col-sm-3"
  }, [_vm._v("program")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-3 text-right"
  }, [_vm._v("platný od")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-2 text-right"
  }, [_vm._v("platný do")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-2 text-right"
  }, [_vm._v("zaplaceno")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-2 text-right"
  })])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.clientMemberships), function(cm) {
    return [
      [_c('tr', {
        staticClass: "row m-0 text-left",
        class: cm.is_valid ? 'font-weight-bold' : '',
        attrs: {
          "data-testid": "client-membership-row"
        }
      }, [_c('td', {
        staticClass: "col-sm-3",
        class: cm.program.is_valid ? 'font-weight-bold' : ''
      }, [_vm._v(_vm._s(cm.program.name))]), _vm._v(" "), _c('td', {
        staticClass: "col-sm-3 text-right"
      }, [_vm._v(_vm._s(cm.valid_from))]), _vm._v(" "), _c('td', {
        staticClass: "col-sm-2 text-right"
      }, [_vm._v(_vm._s(cm.valid_to))]), _vm._v(" "), _c('td', {
        staticClass: "col-sm-2 text-right"
      }, [_vm._v(_vm._s(_vm._f("boolAndNullToCS")(cm.paid, ' ')) + "\n                                      "), (cm.fakturoid_invoice_id) ? [_c('a', {
        staticClass: "btn btn-sm btn-success text-white",
        attrs: {
          "target": "_blank",
          "href": _vm.setting.hostname + 'membership/' + cm.id + '/invoice/pdf'
        }
      }, [_vm._v("FA")])] : _vm._e()], 2), _vm._v(" "), _c('td', {
        staticClass: "col-sm-2 text-right"
      }, [(!_vm.updateMembershipPending && cm.id !== _vm.membershipToUpdateId) ? _c('button', {
        staticClass: "btn btn-sm btn-link",
        attrs: {
          "data-testid": "client-membership-edit"
        },
        on: {
          "click": function($event) {
            _vm.updateMembership(cm)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-pencil",
        attrs: {
          "aria-hidden": "true"
        }
      })]) : (cm.id === _vm.membershipToUpdateId) ? _c('button', {
        staticClass: "btn btn-sm btn-link",
        on: {
          "click": function($event) {
            _vm.membershipToUpdateId = null
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-times",
        attrs: {
          "aria-hidden": "true"
        }
      })]) : _c('button', {
        staticClass: "btn btn-sm btn-outline-secondary disabled",
        attrs: {
          "disabled": "disabled"
        }
      }, [_c('i', {
        staticClass: "fa fa-pencil",
        attrs: {
          "aria-hidden": "true"
        }
      })]), _vm._v(" "), (!_vm.deleteMembershipPending) ? _c('button', {
        staticClass: "btn btn-sm btn-outline-danger",
        attrs: {
          "data-testid": "client-membership-delete"
        },
        on: {
          "click": function($event) {
            _vm.deleteMembership(cm.id)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-trash-o",
        attrs: {
          "aria-hidden": "true"
        }
      })]) : _c('button', {
        staticClass: "btn btn-sm btn-outline-danger disabled",
        attrs: {
          "disabled": "disabled"
        }
      }, [_c('i', {
        staticClass: "fa fa-trash-o",
        attrs: {
          "aria-hidden": "true"
        }
      })])])]), _vm._v(" "), (cm.note) ? _c('tr', {
        staticClass: "row m-0 no-top-border-td no-padding-top-td"
      }, [_c('td', {
        staticClass: "col-sm-1"
      }), _vm._v(" "), _c('td', {
        staticClass: "col-sm-11 font-italic text-left"
      }, [_vm._v("\n                                        " + _vm._s(cm.note) + "\n                                    ")])]) : _vm._e(), _vm._v(" "), (cm.id === _vm.membershipToUpdateId) ? _c('tr', {
        staticClass: "row m-0 no-top-border-td no-padding-top-td"
      }, [_c('td', {
        staticClass: "col-sm-10"
      }, [_c('form', {
        on: {
          "submit": function($event) {
            $event.preventDefault();
            _vm.putMembership(cm.id)
          }
        }
      }, [_c('div', {
        staticClass: "row"
      }, [_c('div', {
        staticClass: "col-sm-6 form-group"
      }, [_c('label', {
        attrs: {
          "for": "programSelect"
        }
      }, [_vm._v("Program")]), _vm._v(" "), _c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.membershipToUpdate.program.id),
          expression: "membershipToUpdate.program.id"
        }],
        staticClass: "form-control",
        attrs: {
          "data-testid": "client-membership-update-program",
          "id": "programSelect"
        },
        on: {
          "change": [function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.membershipToUpdate.program.id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
          }, function($event) {
            _vm.recalculateDateProgramChanged($event)
          }]
        }
      }, _vm._l((_vm.programs), function(p) {
        return _c('option', {
          attrs: {
            "data-days": p.default_days
          },
          domProps: {
            "value": p.id
          }
        }, [_vm._v(_vm._s(p.name))])
      }))]), _vm._v(" "), _c('div', {
        staticClass: "col-sm-6 form-inline"
      }, [_c('label', {
        staticClass: "mr-sm-2",
        attrs: {
          "for": "paid"
        }
      }, [_vm._v("\n                                                        zaplaceno "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.membershipToUpdate.paid),
          expression: "membershipToUpdate.paid"
        }],
        staticClass: "form-check-input",
        attrs: {
          "type": "checkbox",
          "data-testid": "client-membership-update-paid",
          "id": "paid"
        },
        domProps: {
          "checked": Array.isArray(_vm.membershipToUpdate.paid) ? _vm._i(_vm.membershipToUpdate.paid, null) > -1 : (_vm.membershipToUpdate.paid)
        },
        on: {
          "__c": function($event) {
            var $$a = _vm.membershipToUpdate.paid,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.membershipToUpdate.paid = $$a.concat($$v))
              } else {
                $$i > -1 && (_vm.membershipToUpdate.paid = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.membershipToUpdate.paid = $$c
            }
          }
        }
      })])]), _vm._v(" "), _c('div', {
        staticClass: "col-sm-6 form-inline"
      }, [_c('label', {
        attrs: {
          "for": "validFrom"
        }
      }, [_vm._v("platnost od: ")]), _vm._v(" "), _c('datepicker', {
        attrs: {
          "placeholder": "vybrat datum",
          "format": "dd.MM.yyyy",
          "language": "cs",
          "monday-first": true,
          "full-month-name": true,
          "name": "validFrom",
          "id": "validFrom"
        },
        on: {
          "input": function($event) {
            _vm.recalculateDateValidFromChanged()
          }
        },
        model: {
          value: (_vm.membershipToUpdate.valid_from),
          callback: function($$v) {
            _vm.membershipToUpdate.valid_from = $$v
          },
          expression: "membershipToUpdate.valid_from"
        }
      })], 1), _vm._v(" "), _c('div', {
        staticClass: "col-sm-6 form-inline"
      }, [_c('label', {
        attrs: {
          "for": "validTo"
        }
      }, [_vm._v("platnost do: ")]), _vm._v(" "), _c('datepicker', {
        attrs: {
          "placeholder": "vybrat datum",
          "format": "dd.MM.yyyy",
          "language": "cs",
          "monday-first": true,
          "full-month-name": true,
          "name": "validTo",
          "id": "validTo"
        },
        model: {
          value: (_vm.membershipToUpdate.valid_to),
          callback: function($$v) {
            _vm.membershipToUpdate.valid_to = $$v
          },
          expression: "membershipToUpdate.valid_to"
        }
      })], 1), _vm._v(" "), _c('div', {
        staticClass: "col-sm-12 form-group"
      }, [_c('label', {
        attrs: {
          "for": "note"
        }
      }, [_vm._v("poznámka: ")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.membershipToUpdate.note),
          expression: "membershipToUpdate.note"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "text",
          "data-testid": "client-membership-update-note",
          "aria-describedby": "noteHelp",
          "id": "note"
        },
        domProps: {
          "value": (_vm.membershipToUpdate.note)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.membershipToUpdate.note = $event.target.value
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "col-sm-12 form-group text-center"
      }, [(!_vm.updateMembershipPending) ? _c('button', {
        staticClass: "btn btn-success btn-sm",
        attrs: {
          "data-testid": "client-membership-update-save",
          "type": "submit"
        }
      }, [_vm._v("Uložit")]) : _c('button', {
        staticClass: "btn btn-primary btn-sm disabled",
        attrs: {
          "disabled": "disabled"
        }
      }, [_c('i', {
        staticClass: "fa fa-spinner fa-pulse fa-fw"
      }), _vm._v(" Ukládám")])])])])])]) : _vm._e()]
    ]
  })], 2)])])]), _vm._v(" "), (!_vm.client.membership || (_vm.editMode === true && _vm.membershipToUpdateId === null)) ? _c('div', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.postMembership(_vm.client.id)
      }
    }
  }, [_c('div', {
    staticClass: "row bg-light"
  }, [_c('div', {
    staticClass: "col-sm-12 text-center"
  }, [_c('h5', [_vm._v("Přidání nového programu")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 form-group"
  }, [_c('label', {
    attrs: {
      "for": "programSelect"
    }
  }, [_vm._v("Program")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.membership.program.id),
      expression: "membership.program.id"
    }],
    staticClass: "form-control",
    attrs: {
      "data-testid": "client-membership-program",
      "id": "programSelect"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.membership.program.id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.recalculateDateProgramChanged($event)
      }]
    }
  }, _vm._l((_vm.programs), function(p) {
    return _c('option', {
      attrs: {
        "data-days": p.default_days
      },
      domProps: {
        "value": p.id
      }
    }, [_vm._v(_vm._s(p.name))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 form-inline"
  }, [(_vm.setting.fakturoid === true) ? [_c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "paid_by_card"
    }
  }, [_vm._v("\n                              platí kartou "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.membership.paid_by_card),
      expression: "membership.paid_by_card"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "data-testid": "client-membership-paid-by-card",
      "id": "paid_by_card"
    },
    domProps: {
      "checked": Array.isArray(_vm.membership.paid_by_card) ? _vm._i(_vm.membership.paid_by_card, null) > -1 : (_vm.membership.paid_by_card)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.membership.paid_by_card,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.membership.paid_by_card = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.membership.paid_by_card = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.membership.paid_by_card = $$c
        }
      }
    }
  }), _vm._v(" (jinak hotově)\n                            ")])] : [_c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "paid"
    }
  }, [_vm._v("\n                              zaplaceno "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.membership.paid),
      expression: "membership.paid"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "data-testid": "client-membership-paid",
      "id": "paid"
    },
    domProps: {
      "checked": Array.isArray(_vm.membership.paid) ? _vm._i(_vm.membership.paid, null) > -1 : (_vm.membership.paid)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.membership.paid,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.membership.paid = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.membership.paid = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.membership.paid = $$c
        }
      }
    }
  })])]], 2), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 form-inline"
  }, [_c('label', {
    attrs: {
      "for": "validFrom"
    }
  }, [_vm._v("platnost od: ")]), _vm._v(" "), _c('datepicker', {
    attrs: {
      "placeholder": "vybrat datum",
      "format": "dd.MM.yyyy",
      "language": "cs",
      "monday-first": true,
      "full-month-name": true,
      "name": "validFrom",
      "id": "validFrom"
    },
    on: {
      "input": function($event) {
        _vm.recalculateDateValidFromChanged()
      }
    },
    model: {
      value: (_vm.membership.valid_from),
      callback: function($$v) {
        _vm.membership.valid_from = $$v
      },
      expression: "membership.valid_from"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 form-inline"
  }, [_c('label', {
    attrs: {
      "for": "validTo"
    }
  }, [_vm._v("platnost do: ")]), _vm._v(" "), _c('datepicker', {
    attrs: {
      "placeholder": "vybrat datum",
      "format": "dd.MM.yyyy",
      "language": "cs",
      "monday-first": true,
      "full-month-name": true,
      "name": "validTo",
      "id": "validTo"
    },
    model: {
      value: (_vm.membership.valid_to),
      callback: function($$v) {
        _vm.membership.valid_to = $$v
      },
      expression: "membership.valid_to"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('label', {
    attrs: {
      "for": "note"
    }
  }, [_vm._v("poznámka: ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.membership.note),
      expression: "membership.note"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "data-testid": "client-membership-note",
      "aria-describedby": "noteHelp",
      "id": "note"
    },
    domProps: {
      "value": (_vm.membership.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.membership.note = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group text-center"
  }, [(!_vm.membershipPending) ? _c('button', {
    staticClass: "btn btn-success btn-sm",
    attrs: {
      "data-testid": "client-membership-save",
      "type": "submit"
    }
  }, [_vm._v("Uložit")]) : _c('button', {
    staticClass: "btn btn-primary btn-sm disabled",
    attrs: {
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw"
  }), _vm._v(" Ukládám")])])])])]) : _vm._e()]) : _vm._e()])], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b38395a","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Client/components/ClientMembership.vue
// module id = 320
// module chunks = 0